export const extractNumbersFromString = (str: string): number => {
  const numbers = str.match(/\d+/g);

  return numbers ? Number(numbers.join('')) : 0;
};
